<template>
  <v-container>
      <v-row>
            <v-col cols="12">
                <v-img max-height="120" contain src="../assets/profile.png"></v-img>
            </v-col>
            <v-col cols="12" class="chat-wrapper">
                <div class="arrow-up"></div>
                <div class="chat">
                    <p>Hi Tom, Ik zie dat je wel een druk weekje achter de rug hebt. Denk je wel een beetje aan jezelf?</p>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" class="py-8">
                <h1>…en vergeet je maatjes niet!</h1>
            </v-col>
            <v-col cols="12" class="mate">
                <v-img max-height="120" contain src="../assets/rosa.png"></v-img>
                <p>Rosa Juch</p>
            </v-col>
            <v-col cols="12" class="mate">
                <v-img max-height="120" contain src="../assets/stan.png"></v-img>
                <p>Stan van den Bersselaar</p>
            </v-col>
            <v-col cols="12" class="mate">
                <v-img max-height="120" contain src="../assets/bart.png"></v-img>
                <p>Bart Ermens</p>
            </v-col>
        </v-row>
        <v-row>
            <v-flex class="payment-btn-wrapper mx-4 my-10">
                <v-btn class="btn-payment" href="/popular-place" x-large color="primary" dark>
                    Waar was je zo druk mee?
                </v-btn>
            </v-flex>
        </v-row>
  </v-container>
</template>
<script>

export default {
  data () {
    return {
      pageTitle: 'DataMate',
      foodItems: Number,
      totalItems: Number,
      newTotalItems: Number,
      newFoodItems: Number,
      foodpercentage: Number,
      newFoodpercentage: Number,
      text: 'jeh',
      
      item: {
                avatar: ''
            }
        }
    },
    props: [
        'listdata'
    ],
    mounted () {
      this.$emit('createdTitle', this.pageTitle);
      this.makeProgress();

    },
    created(){
    },
    computed: {
      foodData() {
        return this.listdata.filter(listdata => listdata.cat === "Food");
        },
    },
    methods: {

      changeAvatar : function() {
        if (this.newFoodpercentage > 0 && this.newFoodpercentage < 20) {
          this.item.avatar = require('@/assets/avatar/head.png');
        } else if (this.newFoodpercentage > 19 && this.newFoodpercentage < 40) {
          this.item.avatar = require('@/assets/avatar/head1.png');
        }
        else if (this.newFoodpercentage > 39 && this.newFoodpercentage < 61) {
          this.item.avatar = require('@/assets/avatar/head2.png');
        }
        else if (this.newFoodpercentage > 59 && this.newFoodpercentage < 80) {
          this.item.avatar = require('@/assets/avatar/head3.png');
        }
        else if (this.newFoodpercentage > 79 && this.newFoodpercentage < 101) {
          this.item.avatar = require('@/assets/avatar/full/avatar4.png');
        }
    },
    makeProgress () {
        console.log('jeh')
        this.totalItems = this.listdata.length
        this.foodItems = this.foodData.length
    
        this.foodpercentage = this.foodItems / this.totalItems * 100

        this.newFoodpercentage = this.foodpercentage
        this.changeAvatar();

      }

    }
   
}
</script>
<style lang="scss">
.chat {
    width: 80%;
    margin: 0 auto;
    background: #252728;
    padding: 20px 10px;
    border-radius: 10px;
    margin-top: -28px;
    font-size: 14px;
    text-align: center;
    z-index: 9;
    
    p{
        color: #ACADAC;
        margin-bottom: 0;
    }
}

h1{
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #EAE6E4;
}

.chat-wrapper{
    margin-top: -40px;
    z-index: 9;
}

.mate{
    p{
        text-align: center;
        font-weight: 800;
        font-size: 13px;
        margin: 10px 0;
    }
}

.arrow-up {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #252728;
    top: 0px;
    text-align: center;
    margin: 0 auto;
    z-index: 9;
    margin-bottom: 28px;
}

.payment-btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    bottom: 20px;
    margin: 0 auto;
}
.btn-payment{
    font-size: 18px;
    text-transform: inherit;
    font-weight: 500;
    width: 100%;
}
</style>
<style lang="scss">

.chat {
    width: 80%;
    margin: 0 auto;
    background: #252728;
    padding: 20px 10px;
    border-radius: 10px;
    margin-top: -28px;
    font-size: 14px;
    text-align: center;
    z-index: 9;

    strong{
        color: #CBE9BA;
        font-weight: 800;
    }
    
    p{
        color: #ACADAC;
        margin-bottom: 0;
    }
}

h1{
    font-size: 16px;
    font-weight: 700;
    text-align: center;
    color: #EAE6E4;
}

.chat-wrapper{
    margin-top: -40px;
    z-index: 9;
}

.mate{
    p{
        text-align: center;
        font-weight: 800;
        font-size: 13px;
        margin: 10px 0;
    }
}

.map{
    margin: 0 auto;
}

.arrow-up {
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #252728;
    top: 0px;
    text-align: center;
    margin: 0 auto;
    z-index: 9;
    margin-bottom: 28px;
}

.payment-btn-wrapper{
    width: 100%;
    display: flex;
    justify-content: center;
    bottom: 20px;
    margin: 0 auto;
}
.btn-payment{
    font-size: 18px;
    text-transform: inherit;
    font-weight: 500;
    width: 100%;
}
</style>